import * as React from 'react';

import Button from '../Button';
import IMPComponent from '../interfaces/IMPComponent';

interface IActionBarItem extends IMPComponent {
  iconName: string;
  action: () => void;
}

const ActionBarItem = ({ iconName, action }: IActionBarItem) => {
  return (
    <li>
      <Button onClick={action} iconName={iconName} className="Button--transparent Button--noPadding" />
    </li>
  );
};

export default ActionBarItem;



// WEBPACK FOOTER //
// ./src/components/ActionBar/ActionBarItem.tsx